import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupEvent } from '../Types';

const RESOURCE = 'events';

interface IGetGroupEvent extends Omit<IUri, 'resource'> {
  id: string;
  token?: string;
}
interface IGetGroupEventResponse extends IHttpResponse {
  body?: IGroupEvent;
}
export default async function ({
  token,
  ...buildUrlProps
}: IGetGroupEvent): Promise<IGetGroupEventResponse> {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    ...buildUrlProps,
  });

  return BaseService.Get({
    url,
    token,
    skipTimestamp: true,
  });
}
